// extracted by mini-css-extract-plugin
export var darkMode = "_i-0";